export enum TriggerOperatorEnum {
    LessThan = "less-than",
    MoreThan = "more-than",
}
